import React from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "../../../context/AuthContext";

const RoleRedirect = () => {
  const { userRole, pendingEvaluationAthleteId } = useAuth();

  if (pendingEvaluationAthleteId) {
    return <Navigate to="/athlete/onboarding" replace />;
  }

  const target =
    userRole === "admin"
      ? "/admin"
      : userRole === "scout"
        ? "/scout/dashboard"
        : "/athlete/dashboard";
  return <Navigate to={target} replace />;
};

export default RoleRedirect;
